import { render, staticRenderFns } from "./DisableMessaging.vue?vue&type=template&id=32fede14&"
import script from "./DisableMessaging.vue?vue&type=script&lang=js&"
export * from "./DisableMessaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports